import { Box, Grid, InputAdornment, TextField, Typography } from "@mui/material"
import { Controller, useForm } from "react-hook-form"
import { useTranslation } from "react-i18next";
import { ClientProfileService, UserModuleProfileService } from "subModule/src/core/services";
import AlertMessages from "common/Alert/AlertMessages";
import { useSnackbar } from "notistack";
import SimpleModal from "common/Form/Form";
import { useNavigate, useParams } from "react-router-dom";
import ComponentHeaderTwo from "common/ComponentHeaderTwo/ComponentHeaderTwo";
import { ReactComponent as DriverIcon } from "assets/SideBarIcons/driver.svg";
import { ReactComponent as Client } from "assets/SideBarIcons/customer.svg";
import { checkPrivileges } from "Helpers/CheckPrivileges";
import type { BreadcrumbItem } from "Helpers/generalBreadcrumbs";
import {
    buildClientDetailsHref,
    buildClientDriversListHref,
} from "Helpers/customersBreadcrumbs";
import { useFrozenClientEntityTitle } from "Helpers/useFrozenClientBreadcrumbs";
import { ChangeEvent, useEffect, useMemo, useState } from "react";
import Loader from "layout/Loader";
import { GetUserByIdResponse } from "subModule/src/services/user/interface";
import VerticalTabs from "common/ComponentSidebar/ComponentSideBar";
// import DynamicSelect from "common/Select/Select";
import { useSelector } from "react-redux";
import { selectUserInfo } from "features/user/userSlice";
// import { useGetRoleDropdownService } from "subModule/src/services/role/useRole";
import VisibilityOffIcon from '@mui/icons-material/VisibilityOff';
import VisibilityIcon from '@mui/icons-material/Visibility';
import { themes } from "theme/themes";
import { brandingInfo } from "features/server/brandingSlice";
import CommonCheckbox from "common/CheckBox/Checkbox";
import ComponentSubheader from "common/ComponentHeaderTwo/ComponentSubheader";
interface FormData { [key: string]: any; }
interface DriverProps {
  setAddNew?: any;
  driversRefetch?: any;
  accountId?: number;
}
export default function DriversModal(props: DriverProps) {
    const { t } = useTranslation();
    const navigate = useNavigate();
    const params = useParams();
    const { enqueueSnackbar } = useSnackbar();
    // const { data: rolesData, refetch: rolesRefetch } = useGetRoleDropdownService({ pageNumber: 1, size: 1000 });
    // const roles = (rolesData?.pages[0]?.data?.content || []).map((item: { id: number, title: string }) => ({ value: item.id, label: item.title }));
    const branding = useSelector(brandingInfo);
    const themeColors = branding?.attributes?.themeId === 100 ? branding?.attributes?.customTheme : (themes as any)[branding?.attributes?.themeId || 3];
    const loggedInUserData = useSelector(selectUserInfo);
    const primaryLanguage = loggedInUserData?.business?.primaryLanguage;
    const secondaryLanguage = loggedInUserData?.business?.secondaryLanguage;
    const { register, control, handleSubmit, formState: { errors, dirtyFields, isDirty }, reset, watch, setValue } = useForm<FormData>({
        defaultValues: {}
    });
    const [loading, setLoading] = useState<boolean>(params?.driverId && !props?.setAddNew ? true : false);
    const [IsBtnEnabled, setIsBtnEnabled] = useState<boolean>(params?.driverId && !props?.setAddNew ? false : true);
    const [driverLabel, setDriverLabel] = useState("");
    const entityTitle = useFrozenClientEntityTitle();
    const breadcrumbItems: BreadcrumbItem[] = useMemo(() => {
        const crumbs: BreadcrumbItem[] = [
            { labelKey: "customers" },
            { labelKey: "customersList", href: "/clients" },
            {
                labelKey: "name",
                ...(entityTitle ? { label: entityTitle } : {}),
                href: buildClientDetailsHref({
                    id: params?.id,
                    accountId: params?.accountId,
                    invoicingPreference: params?.invoicingPreference,
                }),
            },
            {
                labelKey: "drivers",
                href: buildClientDriversListHref({
                    id: params?.id,
                    accountId: params?.accountId,
                    invoicingPreference: params?.invoicingPreference,
                }),
            },
        ];
        if (params?.driverId && !props?.setAddNew) {
            crumbs.push(
                {
                    labelKey: "name",
                    ...(driverLabel ? { label: driverLabel } : {}),
                },
                { labelKey: "edit" },
            );
        } else if (!props?.setAddNew) {
            crumbs.push({ labelKey: "create" });
        }
        return crumbs;
    }, [
        params?.id,
        params?.accountId,
        params?.invoicingPreference,
        params?.driverId,
        entityTitle,
        driverLabel,
        props?.setAddNew,
    ]);
    useEffect(() => {
        // rolesRefetch();
        if (params?.driverId && !props?.setAddNew) {
            if (loading) getByID();
        }
    }, [params]);
    useEffect(() => {
        if (isDirty && params?.driverId) setIsBtnEnabled(true);
    }, [isDirty, dirtyFields]);
    const getByID = () => {
        UserModuleProfileService.getUserByID(+(params as any)?.driverId).then((res: GetUserByIdResponse) => {
            if (res.success) {
                reset({
                    ...res?.data || {},
                    licenseNumber: (res?.data as any)?.attributes?.licenseNumber || '',
                    // roleId: res?.data?.roleId ? { value: res.data?.roleId, label: res?.data?.roleTitle } : null,
                    username: (res?.data?.autoDetails === 2 || res?.data?.autoDetails === 10 || res?.data?.autoDetails === 11 || res?.data?.autoDetails === 12 || res?.data?.autoDetails === 20 || res?.data?.autoDetails === 21) ? "" : res?.data?.username,
                });
                setDriverLabel(res?.data?.name || "");
                setLoading(false);
            } else {
                enqueueSnackbar(<AlertMessages text={res.message || "Something went wrong"} />, { variant: 'error' });
            }
        }).catch((err: any) => { console.error("===", err); });
    }
    const onSubmit = (data: any) => {
        setIsBtnEnabled(false);
        if (params?.driverId && !props?.setAddNew) {
            delete data.showConfirmPassword; delete data.showPassword; delete data.confirmPassword;
            UserModuleProfileService.updateUser(+params?.driverId, {
                ...data,
                // roleId: data?.roleId?.value ? data?.roleId?.value : null,
                username: data.username,
                email: data.username,
                accountId: +(params as any)?.accountId,
            }).then((response: any) => {
                if (response.success) {
                    setDriverLabel(data?.name || "");
                    if(data.loginAccess && data.password) {
                        UserModuleProfileService.updatePassword({
                            email: data.username,
                            newPassword: data.password
                        }).then((res: any) => {
                            if (res.success) {
                                enqueueSnackbar(<AlertMessages statusCode={res.status} text={t('driver') + ' ' + t('updated') + ' ' + t('successfully')} />, { variant: 'success' });
                                navigate(-1);
                            } else {
                                enqueueSnackbar(<AlertMessages text={res?.message} />, { variant: 'error' });
                            }
                            setIsBtnEnabled(true);
                        }).catch((err: any) => {
                            console.error("===", err);
                            setIsBtnEnabled(true);
                            enqueueSnackbar(<AlertMessages text={err?.message || err?.data?.message || "Something went wrong"} />, { variant: 'error' });
                        });
                    } else {
                        enqueueSnackbar(<AlertMessages statusCode={response.status} text={t('driver') + ' ' + t('updated') + ' ' + t('successfully')} />, { variant: 'success' });
                        navigate(-1);
                    }
                } else {
                    enqueueSnackbar(<AlertMessages text={t(response?.message)} />, { variant: 'error' });
                }
                setIsBtnEnabled(true);
            }).catch((err: any) => {
                console.error("===", err);
                setIsBtnEnabled(true);
                enqueueSnackbar(<AlertMessages text={err?.message || err?.data?.message || "Something went wrong"} />, { variant: 'error' });
            });
        } else {
            delete data.showConfirmPassword; delete data.showPassword; delete data.confirmPassword;
            ClientProfileService.createDriver({
                ...data,
                // roleId: data?.roleId?.value ? data?.roleId?.value : null,
                accountId: props?.setAddNew ? props?.accountId : +(params as any)?.accountId,
                email: data.username,
                active: true
            }).then((response: any) => {
                if (response.success) {
                    enqueueSnackbar(<AlertMessages statusCode={response.status} text={t('driver') + ' ' + t('created') + ' ' + t('successfully')} />, { variant: 'success' });
                    if (props?.setAddNew) {
                        props?.setAddNew(false);
                        props.driversRefetch();
                    } else navigate(-1);
                } else {
                    setIsBtnEnabled(true);
                    enqueueSnackbar(<AlertMessages text={t(response?.message)} />, { variant: 'error' });
                }
            }).catch((err: any) => {
                console.error("===", err);
                setIsBtnEnabled(true);
                enqueueSnackbar(<AlertMessages text={err?.message || err?.data?.message || "Something went wrong"} />, { variant: 'error' });
            });
        }
    };
    const handleChangeTabs = (tabId: number) => {
        if (tabId === 0) navigate(`/client/${params?.id}/account/${params?.accountId}/invoicingPreference/${params?.invoicingPreference}`);
        else if (tabId === 1) navigate(`/client/${params?.id}/account/${params?.accountId}/update-password/invoicingPreference/${params?.invoicingPreference}`);
        else if (tabId === 2) navigate(`/client/${params?.id}/account/${params?.accountId}/drivers/invoicingPreference/${params?.invoicingPreference}`);
        else if (tabId === 3) navigate(`/client/${params?.id}/account/${params?.accountId}/vehicles/invoicingPreference/${params?.invoicingPreference}`);
        else if (tabId === 4) navigate(`/client/${params?.id}/account/${params?.accountId}/invoices/invoicingPreference/${params?.invoicingPreference}`);
        else if (tabId === 5) navigate(`/client/${params?.id}/account/${params?.accountId}/delivery-notes/invoicingPreference/${params?.invoicingPreference}`);
        else if (tabId === 6) navigate(`/client/${params?.id}/account/${params?.accountId}/payments/invoicingPreference/${params?.invoicingPreference}`);
        else if (tabId === 7) navigate(`/client/${params?.id}/account/${params?.accountId}/reviews/invoicingPreference/${params?.invoicingPreference}`);
        else if (tabId === 8) navigate(`/client/${params?.id}/account/${params?.accountId}/integrations/invoicingPreference/${params?.invoicingPreference}`);
    }
    const tabs = [
        { id: 0, title: `edit`, child: <></> },
        { id: 1, title: `updatePassword`, child: <></> },
        { id: 2, title: `drivers`, child: <></> },
        { id: 3, title: `vehicles`, child: <></> },
        { id: 4, title: `invoices`, child: <></> },
        { id: 5, title: `deliveryNotes`, child: <></> },
        { id: 6, title: `payments`, child: <></> },
        { id: 7, title: `reviews`, child: <></> },
        { id: 8, title: `integrations`, child: <></> },
    ];
    const disableTabs = tabs.map(tab => tab.id).filter(tabId => {
        switch (tabId) {
            case 0:
                return !checkPrivileges('ROLE_CLIENT_UPDATE');
            case 1:
                return !checkPrivileges('ROLE_CHANGE_PASSWORD');
            case 2:
                return !checkPrivileges('ROLE_CLIENT_UPDATE');
            case 3:
                return !checkPrivileges('ROLE_VEHICLE_VIEW');
            case 4:
                return !checkPrivileges('ROLE_INVOICE_VIEW');
            case 5:
                return !checkPrivileges('ROLE_DELIVERY_NOTE_VIEW');
            case 6:
                return !checkPrivileges('ROLE_PAYMENT_VIEW');
            case 7:
                return false;
            case 8:
                return false;
            default:
                return false;
        }
    });
    // const checkDisabledTabs = () => {
    //   const updatedDisableTabs = [...disableTabs];
    //   if (Number(params?.invoicingPreference) !== 2) {
    //     if (!updatedDisableTabs.includes(5)) {
    //       updatedDisableTabs.push(5);
    //     }
    //   }

    //   return updatedDisableTabs;
    // }
    return (<>
        {props?.setAddNew ? null : <ComponentHeaderTwo
            breadcrumbItems={breadcrumbItems}
            showBtn={true}
            showSaveBtn={false}
            onClick={() => navigate(`/clients`)}
            heading={props?.setAddNew ? t('addDriver') : (t('customer') + ' (' + t('company') + ')')}
            icon={<Client style={{ fill: '#000', width: '30px', height: '30px', marginTop: '3px' }} />}
            btnText={"back"}
            btnType={"back"}
            showCreateBtn={checkPrivileges("ROLE_CLIENT_CREATE")}
        />}
        <Box className='flex'>
            {props?.setAddNew ? null : <VerticalTabs tabs={tabs} selectedIndex={2} handleChangeTabs={handleChangeTabs} disableTabNo={disableTabs} />}
            {loading ? <Loader /> : <div className='w-[100%] mt-[10px]'>
                {props?.setAddNew ? null : <ComponentSubheader
                    showBtn={false}
                    showSaveBtn={false}
                    onClick={() => navigate(-1)}
                    onSubmit={handleSubmit(onSubmit)}
                    heading={params?.driverId ? t('editDriver') : t('addDriver')}
                    icon={<DriverIcon height={28} width={28} />}
                    btnText={"back"}
                    btnType={"back"}
                    isBtnEnabled={IsBtnEnabled}
                    showCreateBtn={checkPrivileges("ROLE_CLIENT_CREATE")}
                />}
                <SimpleModal
                    visable={true}
                    title={params?.driverId && !props?.setAddNew ? "editDriver" : "addDriver"}
                    isButtonVisable={true}
                    isVisableBtn={IsBtnEnabled}
                    btnclosetext="Back"
                    buttonText={params?.driverId && !props?.setAddNew ? "update" : "submit"}
                    attBtnNotshow={false}
                    notVisableBackbtn={true}
                    showPortList={handleSubmit(onSubmit)}
                    formSubmit={handleSubmit(onSubmit)}
                    entityPopup={props?.setAddNew}
                    padding={!props?.setAddNew}
                    content={
                        <Grid container component="form" id="form" rowSpacing={3} columnSpacing={2} onSubmit={handleSubmit(onSubmit)}>
                            {params?.driverId && (watch('totalDueAmount') || watch('totalDueAmount') === 0) ? <Grid item xs={12}>
                                <Typography className="font-semibold font-Saira text-[14px] flex gap-1 justify-end" sx={{ color: themeColors?.primary }}>
                                    <span className="font-medium italic" style={{ color: themeColors?.secondary }}>{t('totalDueAmount')}</span>
                                    <span style={{ color: themeColors?.secondary }}>:</span>
                                    <span className="font-bold">
                                        {new Intl.NumberFormat('en', {
                                        notation: 'standard',
                                        maximumFractionDigits: 2,
                                        }).format((watch('totalDueAmount') || ''))}
                                    </span>
                                    <span className="font-[400] uppercase">{loggedInUserData?.business?.currency || ''}</span>
                                </Typography>
                            </Grid> : null}
                            <Grid item xs={12} md={3}>
                                <TextField
                                    {...register("name", { validate: { required: (value) => value.trim() !== '' || t('This field is required.'), } })}
                                    label={`${!primaryLanguage ? t('primary') : ''} ${t('name')} ${primaryLanguage ? ` (${primaryLanguage})` : ''} *`}
                                    placeholder={(`${!primaryLanguage ? t('primary') : ''} ${t('name')} ${primaryLanguage ? ` (${primaryLanguage})` : ''} *`).replace(/\s+/g, ' ').trim()}
                                    title={(`${!primaryLanguage ? t('primary') : ''} ${t('name')} ${primaryLanguage ? ` (${primaryLanguage})` : ''} *`).replace(/\s+/g, ' ').trim()}
                                    fullWidth
                                    error={!!errors.name}
                                    helperText={errors.name?.message as string}
                                    InputLabelProps={{ shrink: true }}
                                />
                            </Grid>
                            <Grid item xs={12} md={3}>
                                <TextField
                                    {...register("secondaryName")}
                                    label={`${!secondaryLanguage ? t('secondary') : ''} ${t('name')} ${secondaryLanguage ? ` (${secondaryLanguage})` : ''}`}
                                    placeholder={(`${!secondaryLanguage ? t('secondary') : ''} ${t('name')} ${secondaryLanguage ? ` (${secondaryLanguage})` : ''}`).replace(/\s+/g, ' ').trim()}
                                    title={(`${!secondaryLanguage ? t('secondary') : ''} ${t('name')} ${secondaryLanguage ? ` (${secondaryLanguage})` : ''}`).replace(/\s+/g, ' ').trim()}
                                    fullWidth
                                    error={!!errors.secondaryName}
                                    helperText={errors.secondaryName?.message as string}
                                    InputLabelProps={{ shrink: true }}
                                />
                            </Grid>
                            <Grid item xs={12} md={3}>
                                <TextField
                                    {...register("licenseNumber", { validate: { required: (value) => value.trim() !== '' || t('This field is required.'), } })}
                                    label={t('licenseNumber') + ' *'}
                                    InputLabelProps={{ shrink: true }}
                                    placeholder={t('licenseNumber')}
                                    title={t('licenseNumber')}
                                    fullWidth
                                    error={!!errors.licenseNumber}
                                    helperText={errors.licenseNumber?.message as string}
                                />
                            </Grid>
                            <Grid item xs={12} md={3}>
                                <TextField
                                    type="text"
                                    {...register("phone", {
                                        validate: {
                                            phoneLength: (value) =>
                                                !value || (value.length >= 5 && value.length <= 17) || t('phoneLength'),
                                        },
                                    })}
                                    label={t("phoneNumber")}
                                    placeholder={t("phoneNumber")}
                                    title={t("phoneNumber")}
                                    fullWidth
                                    error={!!errors.phone}
                                    helperText={errors.phone?.message as string}
                                    InputLabelProps={{ shrink: true }}
                                    onChange={(e: ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
                                        const cleaned = e.target.value.replace(/[^0-9+]/g, "");
                                        setValue("phone", cleaned);
                                        if(!IsBtnEnabled) setIsBtnEnabled(true);
                                    }}
                                />
                            </Grid>
                            <Grid item xs={12} md={3}>
                                <TextField
                                    {...register("address")}
                                    label={t('address')}
                                    placeholder={t('address')}
                                    title={t('address')}
                                    fullWidth
                                    error={!!errors.address}
                                    helperText={errors.address?.message as string}
                                    InputLabelProps={{ shrink: true }}
                                    multiline
                                    rows={1}
                                    sx={{
                                        '& .MuiInputBase-fullWidth.MuiInputBase-multiline': { width: '100%', paddingRight: '0px', paddingBottom: 0 },
                                        '& .MuiInputBase-inputMultiline': { resize: 'vertical', minHeight: '29px' }
                                    }}
                                />
                            </Grid>
                            {/* <Grid item xs={12} md={3}>
                                <Controller
                                    name="roleId"
                                    control={control}
                                    defaultValue={null}
                                    rules={{ required: false }}
                                    render={({ field }) => (
                                        <DynamicSelect
                                            label={t("role")}
                                            {...field}
                                            options={roles}
                                            isSearchable
                                            isDisabled={false}
                                            onChange={(selectedOption: any) => field.onChange(selectedOption)}
                                            error={errors.roleId?.message as string}
                                        />
                                    )}
                                />
                            </Grid> */}
                            <Grid item xs={12} md={3}>
                                <Controller
                                    name="loginAccess"
                                    control={control}
                                    defaultValue={false}
                                    render={({ field }) => (
                                        <CommonCheckbox
                                            {...field}
                                            label={t("loginAccess")}
                                            onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
                                                field.onChange(event.target.checked);
                                                if(!event.target.checked) {
                                                    setValue('username', '');
                                                    setValue('password', '');
                                                    setValue('confirmPassword', '');
                                                }
                                            }}
                                            checked={field.value}
                                            color={themeColors?.primary}
                                        />
                                    )}
                                />
                            </Grid>
                            {watch('loginAccess') ? <>
                                <Grid item xs={12} md={3}>
                                    <TextField
                                        type="email"
                                        {...register("username", {
                                            required: watch('loginAccess') ? t("This field is required.") : false,
                                            pattern: { value: /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/, message: t('validEmail') }
                                        },)}
                                        label={t("email") + (watch('loginAccess') ? " *" : '')}
                                        placeholder={t("email") + (watch('loginAccess') ? " *" : '')}
                                        title={t("email") + (watch('loginAccess') ? " *" : '')}
                                        fullWidth
                                        error={!!errors.username}
                                        helperText={errors.username?.message as string}
                                        InputLabelProps={{ shrink: true }}
                                    />
                                </Grid>
                                {/* {params?.driverId ? null : <> */}
                                    <Grid item xs={12} md={3}>
                                        <TextField
                                            type={watch('showPassword') ? 'text' : 'password'}
                                            {...register("password", {
                                                required: !params?.driverId ? t("This field is required.") : false,
                                                validate: !params?.driverId || watch('password')?.length ? {
                                                passwordLength: (value) =>
                                                    value?.length >= 8 || t("minPasswordLength"),
                                                } : undefined,
                                            })}
                                            label={t('password') + (!params?.driverId ? " *" : "")}
                                            placeholder={t('password') + (!params?.driverId ? " *" : "")}
                                            title={t('password') + (!params?.driverId ? " *" : "")}
                                            fullWidth
                                            error={!!errors.password}
                                            helperText={errors.password?.message as string}
                                            InputLabelProps={{ shrink: true }}
                                            InputProps={{
                                                endAdornment: (watch('password') ? <InputAdornment position="end" className="cursor-pointer">
                                                    {watch('showPassword') ? (
                                                        <VisibilityIcon style={{ color: themeColors?.primary }} onClick={() => setValue('showPassword', false)} />
                                                    ) : (
                                                        <VisibilityOffIcon style={{ color: themeColors?.primary }} onClick={() => setValue('showPassword', true)} />
                                                    )}
                                                </InputAdornment> : null),
                                            }}
                                        />
                                    </Grid>
                                    <Grid item xs={12} md={3} className="pt-[12px]">
                                        <TextField
                                            type={watch('showConfirmPassword') ? 'text' : 'password'}
                                            {...register("confirmPassword", {
                                                required: !params?.driverId ? t("This field is required.") : false,
                                                validate: !params?.driverId || watch('password')?.length || watch('confirmPassword')?.length ? {
                                                passwordMatch: (value) =>
                                                    value === watch("password") ||
                                                    t("confirmPasswordNewPassword"),
                                                } : undefined,
                                            })}
                                            label={t("confirmNewPassword") + (!params?.driverId ? " *" : "")}
                                            placeholder={t("confirmNewPassword") + (!params?.driverId ? " *" : "")}
                                            title={t("confirmNewPassword") + (!params?.driverId ? " *" : "")}
                                            fullWidth
                                            error={!!errors.confirmPassword}
                                            helperText={errors.confirmPassword?.message as string}
                                            InputLabelProps={{ shrink: true }}
                                            InputProps={{
                                                endAdornment: (watch('confirmPassword') ? <InputAdornment position="end" className="cursor-pointer">
                                                    {watch('showConfirmPassword') ? (
                                                        <VisibilityIcon style={{ color: themeColors?.primary }} onClick={() => setValue('showConfirmPassword', false)} />
                                                    ) : (
                                                        <VisibilityOffIcon style={{ color: themeColors?.primary }} onClick={() => setValue('showConfirmPassword', true)} />
                                                    )}
                                                </InputAdornment> : null),
                                            }}
                                        />
                                    </Grid>
                                {/* </>} */}
                            </> : null}
                        </Grid>
                    }
                />
            </div>}
        </Box>
    </>)
}